var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 142,
    viewBox: "0 0 108 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18765_227)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.3121 133.832C84.8808 136.561 82.3363 138.493 79.6287 138.155L7.83974 129.183C5.13217 128.845 3.2861 126.363 3.71735 123.635L22.1239 7.17137C22.5548 4.44488 25.0989 2.50919 27.8065 2.84756L99.5955 11.8194C102.303 12.1578 104.149 14.6422 103.719 17.3687L85.3121 133.832ZM99.8746 10.0531L28.0857 1.08129C24.2552 0.602579 20.6647 3.22068 20.0807 6.91603L1.67417 123.379C1.09002 127.075 3.73003 130.471 7.56048 130.95L79.3494 139.922C83.1824 140.401 86.7711 137.783 87.3552 134.087L105.762 17.624C106.346 13.9287 103.708 10.5321 99.8746 10.0531Z",
    fill: "#C6C6C3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6359 114.373L81.5313 123.233L97.0302 25.1675L26.1348 16.3074L10.6359 114.373ZM99.3678 13.2599L94.1852 12.6122L27.2073 4.24977C24.4998 3.91139 22.008 5.53704 21.5778 8.25921L3.17079 124.725C2.9563 126.083 3.30427 127.377 4.03968 128.377C3.94682 128.168 3.86854 127.954 3.80368 127.735C4.43981 129.261 5.83967 130.402 7.61193 130.624L79.401 139.596C82.1086 139.934 84.6531 138.001 85.0844 135.273L103.491 18.8092C103.922 16.0827 102.075 13.5983 99.3678 13.2599Z",
    fill: "#FFFFFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3841 123.222C42.4282 122.852 39.7016 124.624 39.2975 127.181L39.292 127.361C39.7269 124.61 42.482 122.958 45.3713 123.319C48.2614 123.68 50.4108 125.84 49.9596 128.695L50.0093 128.52C50.4135 125.963 48.3426 123.591 45.3841 123.222Z",
    fill: "#C6C6C3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2644 123.98C42.6777 123.657 40.2996 125.209 39.9465 127.443C39.9096 127.677 39.909 127.907 39.915 128.137C40.8439 128.972 41.543 129.734 44.3031 130.079C46.4455 130.347 47.8092 129.921 49.1209 129.286C49.2013 129.067 49.2744 128.847 49.3113 128.614C49.6644 126.379 47.8519 124.304 45.2644 123.98Z",
    fill: "#C6C6C3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.1214 129.286C47.8097 129.921 46.446 130.347 44.3036 130.079C41.5435 129.734 40.8445 128.973 39.9156 128.137L39.9034 128.123L39.9143 128.199C39.9194 128.302 39.9411 128.401 39.9573 128.502C39.978 128.656 40.002 128.811 40.042 128.962C40.0715 129.06 40.1098 129.157 40.1464 129.253C40.2028 129.402 40.2607 129.547 40.3341 129.684C40.3796 129.773 40.4319 129.856 40.4847 129.942C40.5728 130.084 40.6726 130.221 40.7772 130.35C40.8335 130.424 40.8941 130.493 40.9568 130.564C41.0792 130.698 41.2166 130.824 41.3586 130.942L41.5544 131.107C41.7176 131.225 41.8902 131.333 42.0749 131.439L42.2654 131.551C42.4749 131.656 42.6962 131.74 42.9242 131.82L43.0813 131.88C43.3643 131.967 43.6622 132.034 43.9731 132.073L43.9801 132.072L43.9856 132.075L44.0449 132.076C46.3574 132.338 48.426 131.308 49.0669 129.448L49.0948 129.384L49.1415 129.277L49.1214 129.286Z",
    fill: "#9B9D9C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18765_227",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 53,
    y: 13,
    width: 19,
    height: 5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7621 16.2682L54.1432 14.1912C53.9323 14.1649 53.7446 14.0724 53.5876 13.9359C53.6576 14.5852 54.0243 15.0887 54.5462 15.1539L70.0772 17.0949C70.5974 17.1599 71.1093 16.7663 71.377 16.1592C71.1838 16.2518 70.9722 16.2944 70.7621 16.2682Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18765_227)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.7621 16.2682L54.1432 14.1912C53.9323 14.1649 53.7446 14.0724 53.5876 13.9359C53.6576 14.5852 54.0243 15.0887 54.5462 15.1539L70.0772 17.0949C70.5974 17.1599 71.1093 16.7663 71.377 16.1592C71.1838 16.2518 70.9722 16.2944 70.7621 16.2682Z",
    fill: "url(#paint0_linear_18765_227)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66809 116.41L82.8003 125.674L99.0066 23.1323L24.8744 13.8676L8.66809 116.41Z",
    fill: "#3E4141"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3044 85.8373L24.6827 13.8436L24.8745 13.8676L13.5252 85.6776L13.3044 85.8373Z",
    fill: "#FFFFFE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5251 85.6777L24.8744 13.8676L98.815 23.1084L98.6697 24.0275L13.5251 85.6777Z",
    fill: "#515453"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18765_227",
    x1: 62.4826,
    y1: 15.046,
    x2: 62.3465,
    y2: 16.1351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFB0AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#737573"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18765_227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86.5299,
    height: 132,
    fill: "white",
    transform: "matrix(0.992281 0.12401 -0.156108 0.98774 21.14 0.213257)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.307c4df5.svg";
export { ForwardRef as ReactComponent };